import AppPromo from './app-promo'

export default AppPromo
